import { FormControl, FormGroup } from '@angular/forms';
import { SearchModel } from '../../models/search-model';
import { Constants, STATUS } from '../constants.model';

export const employeeSearchModel: SearchModel = {
  label: {
    keyword: 'Keyword',
    modifiedDate: 'Modified Date',
    status: 'Status',
  },
  dataType: {
    keyword: 'string',
    modifiedDate: 'date',
    status: ['select', STATUS],
  },
  form: new FormGroup({
    keyword: new FormControl(),
    modifiedDate: new FormGroup({
      from: new FormControl(),
      to: new FormControl()
    }),
    status: new FormControl()
  }),

  query: (query) => {
    return query;
  },

  table: `bl_fi_mst_entity_hdr`,
  queryCallbacks: {
    keyword: keyword => keyword ? keyword : '',
    status: status => status ? status : '',
    modifiedDate: modifiedDate => {
      if (modifiedDate.from || modifiedDate.to) {
        const from = modifiedDate.from ? modifiedDate.from : modifiedDate.to;
        const to = modifiedDate.to ? modifiedDate.to : modifiedDate.from;
        return `  hdr.updated_date BETWEEN '${from.format(Constants.DATETIMEFORMAT)}' AND '${to.format(Constants.DATETIMEFORMAT)}'`;
      }
      return '';
    },
  },
  additionalCondition: ``
};

